$(document).ready(function(){
  $('input.boxed-radio').change(function(){
    var optionIndex = $(this).attr('data-select');
    var radioValue = $(this).val();
    $('.single-option-selector[data-index="'+optionIndex+'"]').val(radioValue).trigger('change');
  });
  var maxheight = 0;
  $('.option-values').each(function(){
    $(this).find('label').each(function(){
      maxheight = ($(this).height() > maxheight ? $(this).height() : maxheight);
    });
    $(this).children().find('.option-value-name').outerHeight(maxheight);
  });
  
  
  
});